<template>
  <div class="gshow">
    <div class="selection-container">
      <h2>请选择以下选项：</h2>

      <!-- tlist 选择 -->
      <div class="selection-group">
        <h3>距离点位</h3>
        <div class="radio-grid">
          <label
            v-for="item in tlist"
            :key="`${item.value}-${item.label}-${item.upordown}`"
            class="radio-item"
          >
            <input
              type="radio"
              name="tlist"
              :value="item"
              v-model="selectedTlist"
            />
            <span>{{ item.label }} ({{ item.value }}, {{ item.upordown === 0 ? '下行' : '上行' }})</span>
          </label>
        </div>
      </div>

      <!-- orderlist 选择 -->
      <div class="selection-group">
        <h3>棒次</h3>
        <div class="radio-grid">
          <label
            v-for="item in orderlist"
            :key="item.value"
            class="radio-item"
          >
            <input
              type="radio"
              name="orderlist"
              :value="item"
              v-model="selectedOrder"
            />
            <span>{{ item.label }}</span>
          </label>
        </div>
      </div>

      <!-- grouplist 选择 -->
      <div class="selection-group">
        <h3>组别</h3>
        <div class="radio-grid">
          <label
            v-for="item in grouplist"
            :key="item.value"
            class="radio-item"
          >
            <input
              type="radio"
              name="grouplist"
              :value="item"
              v-model="selectedGroup"
            />
            <span>{{ item.label }}</span>
          </label>
        </div>
      </div>

      <!-- 提交按钮 -->
      <button @click="handleSubmit" :disabled="!canSubmit" class="submit-btn">
        提交
      </button>

      <!-- 显示提交结果 -->
      <div v-if="submitResult" class="result">
        <h3>提交结果：</h3>
        <p>距离点位：{{ submitResult.tlist.label }} ({{ submitResult.tlist.value }}, {{ submitResult.tlist.upordown === 0 ? '下行' : '上行' }})</p>
        <p>棒次：{{ submitResult.order.label }}</p>
        <p>组别：{{ submitResult.group.label }}</p>
      </div>
    </div>
    <div class="selection-container2">
      <h2>请输入：</h2>

      <!-- tlist 选择 -->
      <div class="selection-group">
        <h3>选手号码</h3>
        <div class="radio-grid">
          <input
              type="input"
              name="tlist"
              v-model="number"
            />
        </div>
      </div>


      <!-- 提交按钮 -->
      <button @click="handleSubmit2" class="submit-btn">
        提交
      </button>

    </div>
  </div>
    
</template>

<script>
import { sendLink,sendNumber } from '@/libs/api.js'
export default {
  data() {
    return {
      tlist: [
        { value: 'TP2', upordown: 0, label: '1KM' },
        { value: 'TP3', upordown: 0, label: '3KM' },
        { value: 'TP4', upordown: 0, label: '5KM' },
        { value: 'TP5', upordown: 0, label: '7.5KM' },
        { value: 'TP4', upordown: 1, label: '10KM' },
        { value: 'TP3', upordown: 1, label: '12KM' },
        { value: 'TP6', upordown: 1, label: '14KM' },
        { value: 'TP2', upordown: 1, label: '15KM' }
      ],
      orderlist: [
        { value: 1, label: '第一棒' },
        { value: 2, label: '第二棒' },
        { value: 3, label: '第三棒' }
      ],
      grouplist: [
        { value: 'A', label: 'A组' },
        { value: 'B', label: 'B组' },
        { value: 'C', label: 'C组' }
      ],
      selectedTlist: null,
      selectedOrder: null,
      selectedGroup: null,
      submitResult: null,
      number: ''
    }
  },
  computed: {
    canSubmit() {
      return this.selectedTlist && this.selectedOrder && this.selectedGroup;
    }
  },
  methods: {
    handleSubmit() {
      if (!this.canSubmit) return;

      this.submitResult = {
        tlist: this.selectedTlist,
        order: this.selectedOrder,
        group: this.selectedGroup
      };

      sendLink({group:this.selectedGroup.value,tp:this.selectedTlist.value,km:this.selectedTlist.label,upordown:this.selectedTlist.upordown,order:this.selectedOrder.value}).then(res=>{
        console.log(res)
        if(res.success) {  
            this.$dialog({message:res.data.message})
        }
      })

      console.log('提交数据:', this.submitResult);
    },
    handleSubmit2() {
      console.log(this.number,'number')
      sendNumber({number:this.number}).then(res=>{
        console.log(res)
        if(res.success) {  
            this.$dialog({message:res.data.message})
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.gshow{
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 30px;
}
.selection-container {
  width: 60%;
  margin: 20px auto;
  padding: 20px;
  font-family: 'Helvetica Neue', Arial, sans-serif;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.selection-container2 {
  width: 30%;
  margin: 20px auto;
  padding: 20px;
  font-family: 'Helvetica Neue', Arial, sans-serif;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

h2 {
  text-align: center;
  margin-bottom: 24px;
  color: #333;
}

.selection-group {
  margin-bottom: 24px;

  h3 {
    margin-bottom: 12px;
    color: #444;
    font-size: 18px;
    font-weight: 600;
  }
}

.radio-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.radio-item {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;

  &:hover {
    background-color: #eef5ff;
    border-color: #409eff;
  }

  input[type='radio'] {
    margin-right: 8px;
    transform: scale(1.1);
  }

  span {
    font-size: 14px;
    color: #333;
  }
}

/* 选中状态高亮 */
.radio-item input[type='radio']:checked + span {
  color: #409eff;
  font-weight: bold;
}

.submit-btn {
  display: block;
  width: 100%;
  padding: 12px;
  background-color: #409eff;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }

  &:not(:disabled):hover {
    background-color: #337ecc;
  }
}

.result {
  margin-top: 24px;
  padding: 16px;
  background-color: #f0f9eb;
  border: 1px solid #e1f3d8;
  border-radius: 6px;

  h3 {
    margin-top: 0;
    color: #67c23a;
    font-size: 18px;
  }

  p {
    margin: 6px 0;
    font-size: 15px;
    color: #333;
  }
}
</style>